export * from "./engine.renderTargetTexture.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import engine.renderTargetTexture.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./engine.renderTargetTexture.pure";
import { RegisterEnginesExtensionsEngineRenderTargetTexture } from "./engine.renderTargetTexture.pure";
RegisterEnginesExtensionsEngineRenderTargetTexture();
//# sourceMappingURL=engine.renderTargetTexture.js.map